import { FC } from 'react';
import { Stack } from '@mui/material';

import { Tag } from '@components/base';
import useLayoutEntityFilterContext from '@hooks/useLayoutEntityFilter';
import { stringComparator } from '@utils/arrayUtils';

type TagColumnProps = { entityTags: string[] };

const TagColumn: FC<TagColumnProps> = ({ entityTags }) => {
  const { tagValues } = useLayoutEntityFilterContext();

  if (!tagValues) return null;

  const { tags } = tagValues;

  const maxTagDisplayCount = 3;
  const tagMatches = (entityTags?.filter(tag => tags.includes(tag)) || []).sort(stringComparator);
  const remainingTags = (entityTags?.filter(tag => !tags.includes(tag)) || []).sort(
    stringComparator
  );
  const allTags = [...tagMatches, ...remainingTags];

  return entityTags.length > 0 ? (
    <Stack direction='row' spacing={0.5}>
      {allTags.slice(0, maxTagDisplayCount).map(tag => (
        <Tag
          icon='tag'
          key={tag}
          label={tag}
          soft={tags.length > 0 && !tags.includes(tag)}
          title={tag}
        />
      ))}

      {allTags.length - maxTagDisplayCount > 0 && (
        <Tag
          label={`+${allTags.length - maxTagDisplayCount}`}
          soft={tags.length > 0 && tagMatches.length <= maxTagDisplayCount}
          title={allTags.slice(maxTagDisplayCount).join(', ')}
        />
      )}
    </Stack>
  ) : (
    <>-</>
  );
};

export default TagColumn;
